import { jsxs as o, jsx as l } from "react/jsx-runtime";
const t = (r) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...r,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M12.167 29.531a4.135 4.135 0 0 1-4.13-4.13 4.135 4.135 0 0 1 4.13-4.13 4.135 4.135 0 0 1 4.13 4.13 4.135 4.135 0 0 1-4.13 4.13Zm0-6.526a2.398 2.398 0 0 0-2.395 2.396 2.398 2.398 0 0 0 2.395 2.396 2.398 2.398 0 0 0 2.396-2.396 2.398 2.398 0 0 0-2.396-2.396ZM12.298 36.276H5.915v-2.639l6.252-1.657 1.316.35 3.385-.898-4.7-1.246-7.987 2.117v4.244c0 .807.655 1.464 1.46 1.464h6.657v-1.735ZM24.978 29.989a5.743 5.743 0 0 1-5.737-5.737 5.743 5.743 0 0 1 5.737-5.736 5.743 5.743 0 0 1 5.736 5.736 5.743 5.743 0 0 1-5.736 5.737Zm0-9.064a3.331 3.331 0 0 0-3.328 3.327 3.331 3.331 0 0 0 3.328 3.328 3.331 3.331 0 0 0 3.327-3.328 3.331 3.331 0 0 0-3.327-3.327Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M24.826 39.357h-8.531v-3.665l8.683-2.302 2.24.594 4.701-1.246-6.941-1.84-11.093 2.94v5.895c0 1.12.91 2.033 2.029 2.033h8.912v-2.41ZM41.399 31.1c-4.156 0-7.537-3.381-7.537-7.537 0-4.156 3.381-7.537 7.537-7.537 4.156 0 7.537 3.381 7.537 7.537 0 4.156-3.381 7.537-7.537 7.537Zm0-11.909a4.377 4.377 0 0 0-4.372 4.372 4.377 4.377 0 0 0 4.372 4.372 4.376 4.376 0 0 0 4.371-4.372 4.377 4.377 0 0 0-4.371-4.372Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m52.802 43.41 3.17-.848v-6.405L41.4 32.294l-14.574 3.863v7.744a2.671 2.671 0 0 0 2.666 2.672h24.158l-.847-3.162Zm-22.811-4.817 11.408-3.024 11.408 3.024v4.815H29.991v-4.815Z"
        }
      )
    ]
  }
);
export {
  t as Queue
};
